/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { b2b_v1_portfolio_builder_asset_list_filter_BaseAssetListFilter } from './b2b_v1_portfolio_builder_asset_list_filter_BaseAssetListFilter';
import type { core_Asset } from './core_Asset';
export type b2b_v1_portfolio_builder_asset_list_UpdateAssetList = {
    asset_list_filters?: Array<b2b_v1_portfolio_builder_asset_list_filter_BaseAssetListFilter>;
    assets?: Array<core_Asset>;
    name?: string;
    type?: b2b_v1_portfolio_builder_asset_list_UpdateAssetList.type;
};
export namespace b2b_v1_portfolio_builder_asset_list_UpdateAssetList {
    export enum type {
        PORTFOLIO_BUILDER = 'portfolio_builder',
        ASSET_CLASS = 'asset_class',
    }
}

